import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { AudioAction } from '../../../../../../models/interactions.model';
import { FlowActionCardComponent } from '../flow-action-card/flow-action-card.component';

@Component({
  selector: 'app-flow-audio-action',
  imports: [FlowActionCardComponent, MatTooltip],
  templateUrl: './flow-audio-action.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlowAudioActionComponent {
  readonly data = input.required<AudioAction>();
}
